export class SourceAccessError extends Error {
  readonly code = 'SOURCE_BLOCKED';
  constructor(readonly officialUrl: string) {
    super('MANGA Plus bloqueó el acceso desde esta conexión. Abrí la lectura oficial para comprobar la disponibilidad del capítulo.');
    this.name = 'SourceAccessError';
  }
}
export const isSourceAccessBlocked = (error: unknown): error is SourceAccessError => error instanceof Error && 'code' in error && error.code === 'SOURCE_BLOCKED';
